/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface AddField {
    fieldDest?: string;
    schemaDest?: string;
    tableDest?: string;
    type?: AddField.TypeEnum;
    value?: string;
}
export namespace AddField {
    export type TypeEnum = 'String255' | 'String25' | 'String3' | 'String100' | 'String10' | 'String50' | 'TEXT' | 'Int' | 'BigInt' | 'Decimal_5_2' | 'Decimal_8_2' | 'Decimal_11_2' | 'Boolean' | 'DateTime' | 'Date' | 'Time' | 'UUID';
    export const TypeEnum = {
        String255: 'String255' as TypeEnum,
        String25: 'String25' as TypeEnum,
        String3: 'String3' as TypeEnum,
        String100: 'String100' as TypeEnum,
        String10: 'String10' as TypeEnum,
        String50: 'String50' as TypeEnum,
        TEXT: 'TEXT' as TypeEnum,
        Int: 'Int' as TypeEnum,
        BigInt: 'BigInt' as TypeEnum,
        Decimal52: 'Decimal_5_2' as TypeEnum,
        Decimal82: 'Decimal_8_2' as TypeEnum,
        Decimal112: 'Decimal_11_2' as TypeEnum,
        Boolean: 'Boolean' as TypeEnum,
        DateTime: 'DateTime' as TypeEnum,
        Date: 'Date' as TypeEnum,
        Time: 'Time' as TypeEnum,
        UUID: 'UUID' as TypeEnum
    };
}
